module.exports = __webpack_public_path__ + "static/media/queueing-next-patient.95c28f39.png";